import React from 'react';
import styled from 'styled-components';

import CarouselLeft from '@rover/icons/svg/carousel-left.svg';
import CarouselRight from '@rover/icons/svg/carousel-right.svg';
import { Box } from '@rover/kibble/core';

export type Props = {
  onPreviousClick: () => void;
  onNextClick: () => void;
  showNextButton: boolean;
  showPreviousButton: boolean;
};

const Wrapper = styled(Box)`
  svg {
    cursor: pointer;
    padding: 8px;
    margin-left: 8px;
    &[aria-disabled='true'] {
      cursor: not-allowed;
      stroke: ${({ theme }) => theme.colors.interactive_text.disabled};
      fill: ${({ theme }) => theme.colors.interactive_text.disabled};
    }
  }
`;

const DatePickerNavbar = ({
  showNextButton,
  showPreviousButton,
  onPreviousClick,
  onNextClick,
}: Props): JSX.Element => {
  return (
    <Wrapper position="absolute" top="8px" right="12px" left="auto">
      <CarouselLeft
        tabIndex={0}
        role="button"
        aria-label="Previous Month"
        aria-disabled={!showPreviousButton}
        onClick={() => showPreviousButton && onPreviousClick()}
      />
      <CarouselRight
        tabIndex={0}
        role="button"
        aria-label="Next Month"
        aria-disabled={!showNextButton}
        onClick={() => showNextButton && onNextClick()}
      />
    </Wrapper>
  );
};

export default DatePickerNavbar;
